import {computed} from "mobx";
import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import {EventTypeDomainModel} from "./event-type-domain-model";
import {EventTypeImageRequestParams} from "./event-type.image-request-params";
import {EventSubTypeImageRequestParams} from "./event-sub-type.image-request-params";

export class EventTypeViewModel extends BaseViewModel {
  domainModel: EventTypeDomainModel;

  constructor(domainModel: EventTypeDomainModel) {
    super(domainModel);

    this.domainModel = domainModel;
  }

  @computed get subTypeId(): Number{
    return this.domainModel.subTypeId;
  }

  get iconType(): EventTypeImageRequestParams {
    return this.subTypeId > 0 ? EventSubTypeImageRequestParams : EventTypeImageRequestParams;
  }

  get alt(): String {
    return this.name;
  }

  get title(): String {
    return this.name;
  }

  get name(): String {
    return this.domainModel.subTypeName || this.domainModel.name;
  }
}
